const BigWhiteCheckIcon = () => (
	<svg width={63} height={63} viewBox="0 0 63 63" fill="none" xmlns="http://www.w3.org/2000/svg">
		<circle cx={31.5} cy={31.5} r={31} fill="#353535" stroke="#353535" />
		<path
			d="M27.0981 42.4387C26.518 42.4386 25.9617 42.208 25.5516 41.7978L18.9891 35.2353C18.5906 34.8227 18.3701 34.2701 18.3751 33.6966C18.3801 33.123 18.6101 32.5744 19.0157 32.1688C19.4213 31.7632 19.9699 31.5332 20.5435 31.5282C21.117 31.5232 21.6696 31.7437 22.0822 32.1421L26.8947 36.9546L40.6825 19.2206C41.0387 18.7623 41.5624 18.4642 42.1384 18.392C42.7144 18.3198 43.2954 18.4794 43.7537 18.8356C44.2121 19.1918 44.5101 19.7155 44.5823 20.2915C44.6545 20.8674 44.495 21.4485 44.1387 21.9068L28.8262 41.5943C28.636 41.8401 28.3956 42.0426 28.121 42.1882C27.8464 42.3338 27.5439 42.4192 27.2337 42.4387H27.0981Z"
			fill="white"
		/>
	</svg>
);
export default BigWhiteCheckIcon;
